import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { GetIntegracoesWhatsappController } from "../../../../Controllers/Geral/Integracao/IntegracoesController";
import { CadastrarEquipeController } from "../../../../Controllers/HelpDesk/Equipes/EquipesControllers";
import { IIntegracoesDados } from "../../../../Interfaces/Geral/Integracoes/IntegracoesInterface";

import { ICadastroEquipe } from "../../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import UnForm from "../../../../Components/Form";
import { ListarFormulariosController } from "../../../../Controllers/Geral/Formularios/FormulariosControllers";

interface ICadastrarEquipeProps {
    updateList: () => void;
    setShow: (show: boolean) => void;
}

export default function CadastrarEquipe(props: ICadastrarEquipeProps) {
    const [LstIngracoesDados, setLstIngracoesDados] =
        useState<Array<IIntegracoesDados>>();
    const [Numero, setNumero] = useState<String>();

    const { formState, reset } = useForm<ICadastroEquipe>();

    useEffect(() => {
        GetIntegracoesWhatsappController().then((res) => {
            setLstIngracoesDados(res);
        });
    }, []);

    const onSubmit = (formData: ICadastroEquipe) => {
        CadastrarEquipeController({
            DS_EQUIPE_HELP_DESK: formData.DS_EQUIPE_HELP_DESK,
            NR_TELEFONE: formData.NR_TELEFONE,
            FL_ATIVO: formData.FL_ATIVO,
            FL_DISTRIBUICAO: formData.FL_DISTRIBUICAO,
            ID_FORMULARIO: Number(formData.ID_FORMULARIO) ?? 0,
        }).then((res) => {
            props.setShow(false);
            reset();
            props.updateList();
        });
    };

    return (
        <>
            <div className="text-center mb-10">
                <h2 className="font-weight-bold">Cadastro de Equipe</h2>
                <p className="text-muted font-weight-bold">
                    Entre com seu o nome da equipe
                </p>
            </div>
            <UnForm
                className="form"
                id="kt_login_signin_form"
                handleSubmit={onSubmit}
            >
                <div className="form-group border-bottom py-3 b-5">
                    <UnForm.Input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_EQUIPE_HELP_DESK && "is-invalid"
                        }`}
                        type="text"
                        placeholder="Nome da Equipe"
                        name="DS_EQUIPE_HELP_DESK"
                        registerOptions={{
                            required: "Insira o nome da equipe",
                        }}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_EQUIPE_HELP_DESK
                            ? formState.errors.DS_EQUIPE_HELP_DESK.message
                            : ""}
                    </div>
                </div>
                <div className="form-group border-bottom py-1 b-5">
                    <UnForm.Select
                        name="NR_TELEFONE"
                        className={`form-control p-1 placeholder-dark-75 mt-3 ${
                            formState.errors.NR_TELEFONE && "is-invalid"
                        }`}
                        registerOptions={{
                            required: "Selecione um número",
                            min: {
                                value: 1,
                                message: "Favor selecione uma opção",
                            },
                        }}
                        onChange={(e) => {
                            setNumero(e.target.value);
                        }}
                    >
                        {LstIngracoesDados?.length ? (
                            LstIngracoesDados.map((integracao) => {
                                return (
                                    <option
                                        key={
                                            integracao.ID_TIPO_INTEGRACAO_ATRIBUTO
                                        }
                                        value={integracao.DS_VALOR}
                                    >
                                        {integracao.DS_INTEGRACAO}
                                    </option>
                                );
                            })
                        ) : (
                            <option>Não existe nenhum número integrado</option>
                        )}
                    </UnForm.Select>

                    {Numero ? (
                        <div className="d-flex justify-content-center align-itens-center">
                            <span className="label abel-pill label-inline label-dark mt-2">
                                {Numero}
                            </span>
                        </div>
                    ) : (
                        ""
                    )}
                    <div className="invalid-feedback">
                        {formState.errors.NR_TELEFONE
                            ? formState.errors.NR_TELEFONE.message
                            : ""}
                    </div>
                </div>
                <div className="form-group border-bottom py-1 b-5">
                    <UnForm.LazySelect
                        controller={ListarFormulariosController}
                        getDS={(e) => e.DS_FORMULARIO}
                        getKeyValue={(e) => e.ID_FORMULARIO}
                        className="form-control p-2 placeholder-dark-75"
                        name="ID_FORMULARIO"
                        label="Formulário"
                    >
                        <option value={undefined}></option>
                    </UnForm.LazySelect>
                </div>
                <div className="form-row mb-5">
                    <div className="col-12 d-flex flex-column align-itens-center justify-content-center">
                        <div className="text-center font-weight-bold">
                            Equipe de Distribuição:
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-warning d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <UnForm.Switch
                                    color="success"
                                    id="FL_DISTRIBUICAO_STATUS"
                                    name="FL_DISTRIBUICAO"
                                    defaultChecked={false}
                                    type="checkbox"
                                />

                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="submit"
                        id="kt_login_signin_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Cadastrar
                    </button>
                </div>
            </UnForm>
        </>
    );
}
